export default __webpack_public_path__ + "static/media/arrow-right-blue.eba21d2f.svg";